module.exports = __webpack_public_path__ + "img/installmentPayments.35ff2977.svg";